import styled, { css } from "styled-components"

export default {
    "ModalBackground": styled.div`
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 50;

        ${({ $upper }) => $upper && css`
            z-index: 51;
        `}
    `,
    "Modal": styled.div`
        width: 90%;
        min-width: 280px;
        max-width: 767px;
        display: flex;
        flex-direction: column;
        padding: 24px 24px;
        gap: 24px;
        background-color: ${({ theme }) => theme.color["white"]};
        border-radius: 20px;
    `,
    "TitleDiv": styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;

        h2 {
            ${({ theme }) => theme.font["large-semibold"]};
        }

        button {
            width: 12px;
            height: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    `,
}